import React from "react";

type Props = {
  checked?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  disabled?: boolean;
};
const ToggleButton = (props: Props) => {
  return (
    <label className="flex cursor-pointer select-none items-center">
      <div className="relative">
        <input
          type="checkbox"
          checked={props.checked}
          onChange={props.onChange}
          className="sr-only"
          {...props.disabled && { disabled: true }}
        />
        <div
          className={`box block h-5 w-8  rounded-full ${
            props.checked ? "bg-[#65C466]" : "bg-[#E9E9EA]"
          }`}
        ></div>
        <div
          className={`absolute left-0.5 top-0.5 flex h-4 w-4 items-center justify-center rounded-full bg-white transition-transform duration-200 ${
            props.checked ? "translate-x-3" : ""
          }`}
        ></div>
      </div>
    </label>
  );
};

export default ToggleButton;
